import React from 'react';
import SearchableSelect from '../SearchableSelect';
import WaitDurationFields from '../WaitDurationFields';
import { DEFAULT_OPTIONS } from '../../../../FlowchartView/TaskNode/DecisionOptionsModal';
import { formatWaitDuration, getWaitSeconds } from '../../utils/conditionWait';
import './styles.css';

/**
 * TaskConditionRow - A single task condition with optional branch and wait
 */
const TaskConditionRow = ({
  taskEntry,
  taskIndex,
  optionIndex,
  allTasks,
  canRemove,
  onUpdateTask,
  onUpdateBranch,
  onUpdateWait,
  onRemoveTask,
}) => {
  const taskId = typeof taskEntry === 'string' ? taskEntry : taskEntry?.taskId;
  const branch = typeof taskEntry === 'string' ? null : taskEntry?.branch;
  const waitSeconds = typeof taskEntry === 'string' ? null : getWaitSeconds(taskEntry);
  const waitLabel = formatWaitDuration(waitSeconds);

  const selectedTask = allTasks.find(t => t.id === taskId);
  const isDecision = selectedTask?.nodeType === 'decision';
  const options = isDecision ? (selectedTask?.options || DEFAULT_OPTIONS) : [];

  return (
    <div className="conditions-modal__option-task">
      <div className="conditions-modal__task-row">
        <SearchableSelect
          value={taskId || ''}
          options={allTasks}
          onChange={(newTaskId) => onUpdateTask(optionIndex, taskIndex, newTaskId)}
          placeholder="Choose a mission..."
        />

        {isDecision && options.length > 0 && (
          <select
            value={branch || options[0]?.id || ''}
            onChange={(e) => onUpdateBranch(optionIndex, taskIndex, e.target.value)}
            className="conditions-modal__select conditions-modal__select--branch"
            title="Which choice must be selected?"
          >
            {options.map(opt => (
              <option key={opt.id} value={opt.id}>
                → {opt.label || opt.name || 'Choice'}
              </option>
            ))}
          </select>
        )}

        {canRemove && (
          <button
            className="conditions-modal__task-remove"
            onClick={() => onRemoveTask(optionIndex, taskIndex)}
            type="button"
            title="Remove"
          >
            ×
          </button>
        )}
      </div>

      {taskId && (
        <div className="conditions-modal__wait-row">
          <span className="conditions-modal__wait-label">Then wait</span>
          <WaitDurationFields
            seconds={waitSeconds}
            onChange={(nextSeconds) => onUpdateWait?.(optionIndex, taskIndex, nextSeconds)}
          />
        </div>
      )}

      {isDecision && (
        <div className="conditions-modal__decision-hint">
          {(() => {
            const effectiveBranch = branch || options[0]?.id;
            const opt = options.find(o => o.id === effectiveBranch);
            const choice = opt?.label || opt?.name || 'this choice';
            return waitLabel
              ? `Unlocks ${waitLabel} after "${choice}" is selected`
              : `Unlocks when "${choice}" is selected`;
          })()}
        </div>
      )}

      {!isDecision && taskId && waitLabel && (
        <div className="conditions-modal__decision-hint">
          {`Then wait ${waitLabel} after this mission is done`}
        </div>
      )}
    </div>
  );
};

export default TaskConditionRow;
